import type { StudentSessionStatus } from './sessions/types';

/** The student's own standing; missing attendance is not proof of absence. */
export type SessionShown = 'live' | 'upcoming' | 'completed' | 'missed' | 'cancelled';

export function sessionShown(status: StudentSessionStatus | 'DRAFT', participated?: unknown): SessionShown {
  switch (status) {
    case 'RUNNING': return 'live';
    case 'FINISHED': return participated === false ? 'missed' : 'completed';
    case 'CANCELLED': return 'cancelled';
    case 'SCHEDULED':
    case 'DRAFT': return 'upcoming';
  }
}
